import * as React from 'react'

import { EnvironmentContext } from 'config/environment'

interface IntercomData {
  isIntercomAllowed: boolean
  userIsAdmin: boolean
  userName: string
  userId: number
  userEmail: string | null | undefined
  userPhone: string
  companyId: number
  companyCreatedAt: string
  companyName: string
  companySize: string
  companyIndustry: string | null | undefined
  companyCountry: string
}

interface LoadIntercomParams extends IntercomData {
  intercomApiBase: string
  intercomApiId: string
}

export const loadIntercom = ({
  isIntercomAllowed,
  intercomApiBase,
  intercomApiId,
  userName,
  userId,
  userEmail,
  userPhone,
  userIsAdmin,
  companyId,
  companyCreatedAt,
  companyName,
  companySize,
  companyIndustry,
  companyCountry,
}: LoadIntercomParams) => {
  if (!isIntercomAllowed) return

  window.intercomSettings = {
    api_base: intercomApiBase,
    app_id: intercomApiId,
    name: userName,
    user_id: userId,
    email: userEmail,
    phone: userPhone,
    is_admin_dl: userIsAdmin,
    Company_id: companyId,
    company: {
      is_admin_dl: userIsAdmin,
      Market: companyCountry,
      company_id: companyId,
      created_at: companyCreatedAt,
      name: companyName,
      size: companySize,
      industry: companyIndustry,
    },
    hide_default_launcher: true,
  }

  if (window.Intercom) {
    window.Intercom('boot', window.intercomSettings)
    return
  }

  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.async = true
  script.src = `https://widget.intercom.io/widget/${intercomApiId}`
  document.head.appendChild(script)

  script.onload = () => {
    if (window.Intercom) {
      window.Intercom('boot', window.intercomSettings)
    }
  }

  return () => {
    if (document.head.contains(script)) {
      document.head.removeChild(script)
    }
  }
}

const useIntercom = (intercomData: IntercomData) => {
  const { intercomApiBase, intercomApiId } = React.useContext(EnvironmentContext)

  const handleIntercomClick = () => {
    loadIntercom({ ...intercomData, intercomApiBase, intercomApiId })
    if (intercomData.isIntercomAllowed && window.Intercom) {
      window.Intercom('show')
    }
  }

  const handleStartTour = (tour: number) => {
    loadIntercom({ ...intercomData, intercomApiBase, intercomApiId })
    if (intercomData.isIntercomAllowed && window.Intercom) {
      window.Intercom('startTour', tour)
    }
  }

  return { handleIntercomClick, handleStartTour }
}

export default useIntercom
